export const TARIFF_CONST_BUTTON_CLASSNAME = 'formulaBtn';
export const TARIFF_CONST_BUTTON_DATA_ATTR = 'data-variable';
export const TARIFF_CONST_BUTTON_DELETE_LINK_CLASSNAME = 'delete-link';

export const MIN_TARIFF_VALUE = 1;

